import _sortBy from "lodash/sortBy";
import React from 'react';
import AddressWidget from './AddressWidget';
import ContactWidget from './ContactWidget';
import NavigationWidget from './NavigationWidget';
import OpeningHoursWidget from './OpeningHoursWidget';
import SocialWidget from './SocialWidget';
import { jsx as ___EmotionJSX } from "@emotion/react";
function Widget(props) {
  switch (props.widget.widget_name) {
    case 'address':
      return ___EmotionJSX(AddressWidget, {
        widget: props.widget,
        lang: props.lang
      });
    case 'contact':
      return ___EmotionJSX(ContactWidget, {
        widget: props.widget,
        lang: props.lang
      });
    case 'navigation':
      return ___EmotionJSX(NavigationWidget, {
        widget: props.widget,
        lang: props.lang
      });
    case 'social':
      return ___EmotionJSX(SocialWidget, {
        widget: props.widget,
        lang: props.lang
      });
    case 'openingHours':
      return ___EmotionJSX(OpeningHoursWidget, {
        widget: props.widget,
        lang: props.lang
      });
    default:
      return ___EmotionJSX("p", null, "Widget not found :-(");
  }
}
function Widgets(props) {
  const {
    widgets,
    lang
  } = props;
  const sorted = _sortBy(widgets, widget => widget.sort);
  return sorted.map(widget => ___EmotionJSX("div", {
    key: widget.sort
  }, ___EmotionJSX(Widget, {
    widget: widget,
    lang: lang
  })));
}
export default Widgets;